import { commercialPurchaseLoan } from "@/data/loans";
import { useCallback } from "react";
import { LOAN_TYPES } from "@/constants/loanTypes";

import SEO from "@/components/common/SEO";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";

import PartnerBanks from "@/components/landing/PartnerBanks";

export default function CommercialPurchaseLoan() {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return (
    <>
      <SEO {...commercialPurchaseLoan.seo} />

      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...commercialPurchaseLoan.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />

        <LoanOverview {...commercialPurchaseLoan.overview} />

        <LoanBenefits {...commercialPurchaseLoan.benefits} />

        <LoanTypes {...commercialPurchaseLoan.types} />

        <LoanEligibility
          {...commercialPurchaseLoan.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />

        <LoanDocuments {...commercialPurchaseLoan.documents} />

        <LoanProcess {...commercialPurchaseLoan.process} />

        <WhyMoneyMart {...commercialPurchaseLoan.whyMoneyMart} />

        <PartnerBanks />

        <LoanFAQ {...commercialPurchaseLoan.faq} />

        <LoanCTA {...commercialPurchaseLoan.cta} onApply={scrollToLeadForm} />

        <LeadFormSection
          {...commercialPurchaseLoan.leadForm}
          loanType="COMMERCIAL_PURCHASE_LOAN"
        />
      </LoanLayout>
    </>
  );
}
